'use client';
import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { useScrollTracking, useTimeOnPageTracking, trackEvent, getPageType } from 'helpers/customEvents';
import { useAccount } from 'frontastic';

export default function AnalyticsTracker() {
  const pathname = usePathname();
  const { loggedIn } = useAccount();

  const pageType = getPageType(pathname);
  const userType = loggedIn ? 'registered' : 'guest';

  let collection_name = undefined;
  if (pathname.includes('/collection/')) {
    collection_name = pathname.split('/collection/')[1]?.split('/')[0]?.split('?')[0];
  }

  useScrollTracking(collection_name);
  useTimeOnPageTracking(collection_name);

  useEffect(() => {
    trackEvent('pageLoad', { page_type: pageType, user_type: userType });
  }, [pathname, pageType, userType]);

  useEffect(() => {
    const handleGlobalClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest('a');
      if (anchor && anchor.href && anchor.href.toLowerCase().endsWith('.pdf')) {
        trackEvent('pdf_download', { url: anchor.href });
      }
    };
    document.addEventListener('click', handleGlobalClick);
    return () => document.removeEventListener('click', handleGlobalClick);
  }, []);

  return null;
}
